module.exports = __webpack_public_path__ + "static/media/Cancel.3bf4b166.svg";